import _ from 'lodash';
import fetch from 'isomorphic-fetch';

export const FILTER_INIT = 'FILTER_INIT';
export const FILTER_TOGGLE = 'FILTER_TOGGLE';
export const FILTER_CLOSE = 'FILTER_CLOSE';
export const FILTER_APPLY = 'FILTER_APPLY';
export const FILTER_PARAMETER_TOGGLE = 'FILTER_PARAMETER_TOGGLE';
export const FILTER_OPTION_SELECT = 'FILTER_OPTION_SELECT';
export const FILTER_CONFIG_UPDATE = 'FILTER_CONFIG_UPDATE';
export const FILTER_CONFIG_REQUEST = 'FILTER_CONFIG_REQUEST';
export const FILTER_CONFIG_REQUEST_FAILURE = 'FILTER_CONFIG_REQUEST_FAILURE';

export function init(stateKey, config, afterAction) {
    const actions = [
        {
            type: FILTER_INIT,
            config,
            stateKey
        }
    ];

    afterAction && actions.push(afterAction());
    return actions;
}

export function toggleFilter(stateKey) {
    return {
        type: FILTER_TOGGLE,
        stateKey
    };
}

export function closeFilter(stateKey) {
    return {
        type: FILTER_CLOSE,
        stateKey
    };
}

export function applyFilter(stateKey, afterAction) {
    const actions = [
        {
            type: FILTER_APPLY,
            stateKey
        }
    ];
    afterAction && actions.push(afterAction());
    return actions;
}

export function toggleParameter(stateKey, name) {
    return {
        type: FILTER_PARAMETER_TOGGLE,
        name,
        stateKey
    };
}

export function selectOption(stateKey, name, value, apply = false, afterApply) {
    let actions = [
        {
            type: FILTER_OPTION_SELECT,
            name,
            value,
            stateKey
        }
    ];

    if (apply) {
        actions = _.concat(actions, applyFilter(stateKey, afterApply));
    }

    return actions;
}

export function updateConfig(stateKey, config, defaultConfig, afterAction) {
    const actions = [
        {
            type: FILTER_CONFIG_UPDATE,
            config,
            defaultConfig,
            stateKey
        }
    ];

    afterAction && actions.push(afterAction(config, defaultConfig));
    return actions;
}

export function fetchConfig(stateKey, url, defaultConfig, afterAction) {
    return (dispatch) => {
        dispatch({
            type: FILTER_CONFIG_REQUEST,
            url,
            stateKey
        });

        return fetch(url, { credentials: 'include' })
            .then(response => response.json())
            .then((config) => {
                dispatch(
                    updateConfig(
                        stateKey,
                        config,
                        defaultConfig,
                        () => init(stateKey, {}, afterAction)
                    )
                );
            })
            .catch(() => {
                dispatch(
                    updateConfig(
                        stateKey,
                        {},
                        {},
                        () => init(stateKey, {}, afterAction)
                    )
                );
            });
    };
}



// WEBPACK FOOTER //
// ./src/js/modules/Filter/actions/index.js